const styles = {
  footer: {
    display: 'flex',
    height: '1.25em',
    margin: '1.875em 0',
    padding: '.75em 4.8125em',
    width: '100%',
    alignItems: 'center',
  },
  copyRight: {
    color: '#9b9b9b',
    fontSize: '.8125rem',
    height: '1rem',
    lineHeight: '1em',
    marginLeft: 'auto',
  },
};

export default styles;
